import { PcbNodeTypes } from "@buildwithflux/models";
/*
 * NOTE: The interface of this store is still WIP
 * If you feel like having a different view of the data would make performance/your life easier, let's talk about it!
 * – Giulio
 */
export var PcbPrimitiveStoreOperation;
(function (PcbPrimitiveStoreOperation) {
    PcbPrimitiveStoreOperation[PcbPrimitiveStoreOperation["Add"] = 0] = "Add";
    PcbPrimitiveStoreOperation[PcbPrimitiveStoreOperation["Remove"] = 1] = "Remove";
    PcbPrimitiveStoreOperation[PcbPrimitiveStoreOperation["Update"] = 2] = "Update";
    PcbPrimitiveStoreOperation[PcbPrimitiveStoreOperation["UpdateFills"] = 3] = "UpdateFills";
})(PcbPrimitiveStoreOperation || (PcbPrimitiveStoreOperation = {}));
export const SupportedNodeTypes = [
    // Silk
    PcbNodeTypes.circle,
    PcbNodeTypes.line,
    PcbNodeTypes.rectangle,
    PcbNodeTypes.text,
    // Direct Copper
    PcbNodeTypes.pad,
    PcbNodeTypes.routeSegment,
    PcbNodeTypes.via,
    // Indirect Copper
    PcbNodeTypes.fill,
    PcbNodeTypes.polygon,
    // Meta
    PcbNodeTypes.zone,
];
//# sourceMappingURL=types.js.map